import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const itenaryApi = createApi({
  reducerPath: "itenaryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getItenaryList: builder.query({
      query: (page) => `api/staff/getItinerary?page=${page}&size=10`,
    }),
    getItenaryDetails: builder.query({
      query: (id) => `api/staff/itinerary/edit/${id}`,
    }),
    createItenary: builder.mutation({
      query: (newItenatyData) => ({
        url: `/api/staff/itinerary/add`,
        method: "POST",
        body: newItenatyData,
      }),
    }),
    editItenary: builder.mutation({
      query: (editItenatyData) => ({
        url: `/api/staff/itinerary/edit`,
        method: "POST",
        body: editItenatyData,
      }),
    }),
    getItinerarySearch: builder.query({
      query: (searchkey) => `/api/staff/searchItinerary/${searchkey}`,
    }),
  }),
});

export const { useGetItenaryListQuery, useGetItenaryDetailsQuery, useCreateItenaryMutation, useEditItenaryMutation, useLazyGetItinerarySearchQuery } = itenaryApi;
